import { styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors, linkStyles, spacing } from '#/theme/theme';

export const PageFooterCentralLinksHolder = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[24]};

  > *:not(:last-child) {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -12px;
      height: 16px;
      width: 1px;
      background: currentcolor;
      pointer-events: none;
    }
  }
`;

export const PageFooterCentralLink = styled(ButtonOrLink)`
  ${linkStyles};

  position: relative;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.lightContentGrey};
`;
